// NOTE: `rtcoData` uses `undefined` for "loading / in-flight" after a fetch is dispatched.
// `null` is the Redux default and means idle or API "no row"; objects are promo payloads.
// Readiness: `rtcoData !== undefined`.
const rtcoP13nSelector = store => store.p13n?.rtcoData;

export { rtcoP13nSelector };
